import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {JWTAuthRequest, JwtAuthResponse} from "../model/Credential";
import {CustomerUser} from "../model/CustomerUser";
import {apiconfig} from "../app/api.config";
import * as CryptoJS from 'crypto-js';

// pour pouvoir injecter le httpclient
@Injectable()
export class AuthService {

  isAuth = false;
  loggedUser: CustomerUser;
  apiConfig: any = apiconfig;

  constructor(private httpClient: HttpClient) {
  }

  /**
   * compute authentication headers to add to http requests
   * @returns {HttpHeaders}
   */
  getHttpAuth() {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + this.loggedUser.jwtToken);
    headers = headers.append("Content-Type", "application/json");
    return headers;
  }

  getHttpAuthNoJson() {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + this.loggedUser.jwtToken);
    return headers;
  }

  getHeaderNoAuth() {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    return headers;
  }


  signInUser(credentials: JWTAuthRequest): Promise<CustomerUser> {

    return this.httpClient.post<JwtAuthResponse>(this.apiConfig.API_URL + "/auth/jwt-auth", credentials, {headers: this.getHeaderNoAuth()}).toPromise()
      .then(resp => {
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", "Bearer " + resp.jwttoken);
        headers = headers.append("Content-Type", "application/json");

        return this.httpClient.get<CustomerUser>(this.apiConfig.API_URL + "/user/customer-user-profile", {headers: headers}).toPromise().then(customerUser => {
          this.loggedUser = CustomerUser.fromJson(customerUser);
          this.loggedUser.jwtToken = resp.jwttoken;
          console.log(this.loggedUser)
          return this.loggedUser;
        });

      }).catch(err => {
        console.log("Could not auth", err)
        throw err;
      });
  }


  buildLogaToken(): string {

    let keyHex: string = CryptoJS.enc.Utf8.parse("Gr3G4S3nSKrft392");
    let ciphertext: string = CryptoJS.AES.encrypt(this.loggedUser.login + "|" + this.loggedUser.jwtToken + "|" + new Date().getTime(), keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();

    // make it base64 compliant with Apache Commons URLSafe
    ciphertext = ciphertext.replace(/\//g, '_').replace(/\+/g, '-').replace(/\=+$/, '');

    return ciphertext;

  }

  buildAnimaInputFieldToken(logaWorkDayId: number): string {

    if (logaWorkDayId == null)
      return "";

    let keyHex: string = CryptoJS.enc.Utf8.parse("Gr3G4S3nSKrft392");
    let ciphertext: string = CryptoJS.AES.encrypt("CL" + "|" + logaWorkDayId + "|" + new Date().getTime(), keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();

    // make it base64 compliant with Apache Commons URLSafe
    ciphertext = ciphertext.replace(/\//g, '_').replace(/\+/g, '-').replace(/\=+$/, '');

    return ciphertext;

  }

  buildAnimaDashboardToken(operationId: number, rolName: string): string {

    if (operationId == null)
      return "";

    let keyHex: string = CryptoJS.enc.Utf8.parse("Gr3G4S3nSKrft392");
    let ciphertext: string = CryptoJS.AES.encrypt(rolName + "|" + new Date().getTime() + "|" + operationId, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();

    // make it base64 compliant with Apache Commons URLSafe
    ciphertext = ciphertext.replace(/\//g, '_').replace(/\+/g, '-').replace(/\=+$/, '');

    return ciphertext;

  }


  buildAnimaInputFieldTokenWithTime(logaWorkDayId: number, time: number): string {

    if (logaWorkDayId == null)
      return "";

    let keyHex: string = CryptoJS.enc.Utf8.parse("Gr3G4S3nSKrft392");
    let ciphertext: string = CryptoJS.AES.encrypt("CL" + "|" + logaWorkDayId + "|" + time, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();

    // make it base64 compliant with Apache Commons URLSafe
    ciphertext = ciphertext.replace(/\//g, '_').replace(/\+/g, '-').replace(/\=+$/, '');

    return ciphertext;

  }

  getLoggedUser(): CustomerUser {
    return this.loggedUser;
  }

  logOut() {
    this.loggedUser = null;
    this.isAuth = true;
  }

  /**
   * convenient null safe method to check if a user is allowed to plan
   */
  isLoggedUserAllowedToPlan(): boolean {
    return this.loggedUser != null && this.loggedUser.customerPlanningAllowed;
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.ts